import Page from '../../classes/Page';
import statisticsIntroChart from './introChart';
import statisticsTables from './tablesView';
import statisticsTradeLines from './tradeLines';

const
	introChart = statisticsIntroChart(),
	tables = statisticsTables(),
	tradeLines = statisticsTradeLines()
;


const statisticsPage = new Page({
	onInit() {
		introChart.init();
		tables.init();
	},
	onDestroy() {
		introChart.destroy();
		tables.destroy();
	},
	name: 'statistics',
	rootElementId: 'js-statistics-page',
	resizeDependentMethods: [
		introChart.setPointsPosition,
		tables.setView,
		tradeLines.setPosition
	]
});

export default statisticsPage;
